import { Injectable, Inject } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Cradlepoint } from '@app/shared/models/cradlepoint/cradlepoint.model';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { timeout, retry, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CradlepointsService {
    private apiUrl = `${environment.apiHost}/cradlepoint`;

    constructor(private http: HttpClient, @Inject(OKTA_AUTH) public oktaAuth: OktaAuth) {
    }

    async findByStoreNumber(storeNumber: string) {
        return this.http.get<Cradlepoint>(`${this.apiUrl}/routers?storeNumber=${storeNumber}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(4000),
                retry(3),
                catchError(error => of("Request for cradlepoints timed out!"))
            );
    }

    async getSignalHealth(storeNumber: string) {
        return this.http.get<Cradlepoint>(`${this.apiUrl}/signal-health?storeNumber=${storeNumber}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(20000),
                retry(3),
                catchError(error => of("Request for signal health timed out!"))
            );
    }

    async getAllCradlepoints() {
        return this.http.get(`${this.apiUrl}/all-routers`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(4000),
                retry(3),
                catchError(error => of("Request for all cradlepoints timed out!"))
            );
    }

    async getLanAvailability(storeNumber: string) {
        return this.http.get(`${this.apiUrl}/lan-availability?storeNumber=${storeNumber}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(20000),
                retry(3),
                catchError(error => of("Request for LAN availability timed out!"))
            );
    }

    async findByMacAddress(mac: string) {
        return this.http.get<Cradlepoint>(`${this.apiUrl}/routers?mac=${mac}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken(),
                        "Cache-Control":"max-age=0" }
                )
            }).pipe(
                timeout(4000),
                retry(3),
                catchError(error => of(error))
            )
    }

    async getNetworkDevices(storeNumber: string) {
        return this.http.get(`${this.apiUrl}/network-devices?storeNumber=${storeNumber}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken(),
                        "Cache-Control":"max-age=0" }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of(error))
            )
    }

    async patchBuildConfig(mac: string, store_number: string, msp: string){
        return this.http.patch(`${this.apiUrl}/build-config`,
        {
            "mac": mac,
            "storeNumber": store_number,
            "msp": msp
        },
        {
            headers: new HttpHeaders(
                { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken(),
                
            }
            )
        }).pipe(
            timeout(60000),
            catchError(error => of(error))
        );
    }

    

}

